import { DialogService, GridAction } from '@eforall/dashboard';
import { PersonVolunteeringRow } from '../person-volunteering.part';

export function getActions(dialog: DialogService) {

	const actions: GridAction<PersonVolunteeringRow>[] = [];

	return actions;
}